var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('Nuxt',{attrs:{"keep-alive":"","keep-alive-props":{ max: 10 }}}),_vm._v(" "),_c('FooterPlanted')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }